import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useRef, useState } from 'react';

const CreaCliente = ({ onSave }) => {
    const [identificador, setIdentificador] = useState('');
    const [nombre, setNombre] = useState('');
    const [procesa, setProcesa] = useState(false);

    const toastCli = useRef(null);

    const handleGuardar = () => {
        if (identificador.length === 0 || nombre.length === 0) {
            toastCli.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe llenar los campos Identificador y Nombre' });
            return;
        }
        setProcesa(true);
        //console.log ('Validando campos ')
        const dataGuardar = {
            identificador: identificador,
            nombre: nombre.toUpperCase()
        };
        onSave(dataGuardar);
    };
    return (
        <div className="card">
            <Toast ref={toastCli} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-6">
                    <label>Identificador</label>
                    <InputText value={identificador} onChange={(evt) => setIdentificador(evt.target.value)} placeholder="Identificador del Cliente" keyfilter="int" disabled={procesa} maxLength={20} />
                </div>
                <div className="field col-12 md:col-6">
                    <label>Nombre</label>
                    <InputText value={nombre} onChange={(evt) => setNombre(evt.target.value)} placeholder="Nombre del Cliente" disabled={procesa} style={{ textTransform: 'uppercase' }} maxLength={100} />
                </div>
                <div className="field col-12 md:col-6">
                    <span></span>
                </div>
                <div className="field col-12 md:col-6">
                    <Button label="Guardar" onClick={handleGuardar} loading={procesa} />
                </div>
            </div>
        </div>
    );
};

export default CreaCliente;
